import { Stack } from '@mui/material';
import { Typography } from '@mui/material';
import { Card } from '@mui/material';
import React from 'react';
import {
  BLACK_COLOR,
  BLUE_COLOR,
  WHITE_COLOR,
} from '../../../../constants/ColorsConst';

const CardNivelesAcademicosComponent = ({ data, activo, onClick }) => {
  return (
    <Card
      sx={{
        backgroundColor: activo ? BLUE_COLOR : '#f4f4f4',
        mb: 1.5,
        p: 1,
        cursor: 'pointer',
        color: activo ? WHITE_COLOR : BLACK_COLOR,
        '&:hover': {
          backgroundColor: activo ? WHITE_COLOR : BLUE_COLOR,
          color: activo ? BLUE_COLOR : WHITE_COLOR,
        },
      }}
      onClick={onClick}
    >
      <Stack>
        <Typography
          sx={{
            fontWeight: 'bold',
          }}
        >
          {data.nombre}
        </Typography>
        <Typography>{data.tipoNivelAcademico}</Typography>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {data.abrev && (
            <Typography>
              <strong>Abrev: </strong>
              {data.abrev}
            </Typography>
          )}

          <Typography>
            <strong>Numero: </strong>
            {data.numero}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

export default CardNivelesAcademicosComponent;
